module.exports = __webpack_public_path__ + "static/img/rc.c1c7bcf3.png";